import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { Link } from "react-router-dom";
import NoData from "../NoData";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import AddButton from "../../../../../../../ui/AddButton";

const styles = () => ({
  heading: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px"
  },
  title: {
    fontSize: 14,
    lineHeight: "18px",
    color: "#000000",
    marginRight: "8px",
  },
});

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      "&  p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px"
      },
      "& svg": {
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  }
}))(MuiExpansionPanelDetails);

const ExpandPanelBlock =({block, modules,
                           classes,
                           openModulesDialog,
                      expandedBlock,
                      handleChangeBlockPanel,
                      setSelectedBlock,
                      setUpdateBlockOpen,
                      setOpenDeleteModal,
                         setOpenDeleteModuleModal,
                         setSelectedModule}) => {

  return (
    <ExpansionPanel
      key={block.id}
      square
      expanded={expandedBlock === `panel${block.id}`}
      onChange={handleChangeBlockPanel(`panel${block.id}`)}
    >
      <ExpansionPanelSummary>
        <div style={{ display: "flex" }}>
          {expandedBlock === `panel${block.id}` ? (
            <ArrowDropDownIcon />
          ) : (
            <ArrowRightIcon />
          )}
            <Typography> {`${block.number}. ${block.name}`} </Typography>
        </div>
        <div style={{ paddingRight: "16px" }}>
          <Tooltip title="Редактировать" placement="top-start">
            <IconButton
              size="small"
              onClick={event => {
                setSelectedBlock(block.id);
                setUpdateBlockOpen(true);
                event.stopPropagation();
              }}
            >
              <EditOutlinedIcon
                fontSize="small"
                style={{ fill: "#93A7BE" }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Удалить" placement="top-start">
            <IconButton
              size="small"
              style={{
                marginLeft: "6px"
              }}
              onClick={event => {
                setSelectedBlock(block.id);
                setOpenDeleteModal(true);
                event.stopPropagation();
              }}
            >
              <DeleteForeverOutlinedIcon
                fontSize="small"
                style={{
                  fill: "#93A7BE"
                }}
              />
            </IconButton>
          </Tooltip>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <div className={classes.heading}>
          <Typography className={classes.title}>
            Модули
          </Typography>
          <AddButton
            onClick={ () => {
              openModulesDialog();
              setSelectedBlock(block.id);
            }}
          />
        </div>
        {modules && modules.length > 0 ?
          modules.map(module => {
            return (
              <ExpansionPanel
                key={module.id}
                square
                expanded={true}
              >
                <ExpansionPanelSummary>
                  <div style={{ display: "flex" }}>
                    <Link target="_blank"
                          title="Открыть в новой вкладке"
                          key={`/work/app/manage/resources/programs/mymodules/${module.id}`}
                          to={`/work/app/manage/resources/programs/mymodules/${module.id}`}>
                      <Typography> {`${module.number}. ${module.moduleName}`} </Typography>
                    </Link>

                  </div>
                  <div style={{ paddingRight: "16px" }}>
                    <Tooltip title="Удалить модуль" placement="top-start">
                      <IconButton
                        size="small"
                        style={{
                          marginLeft: "6px"
                        }}
                        onClick={event => {
                          setSelectedModule(module.id);
                          setOpenDeleteModuleModal(true);
                          event.stopPropagation();
                        }}
                      >
                        <DeleteForeverOutlinedIcon
                          fontSize="small"
                          style={{
                            fill: "#93A7BE"
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </ExpansionPanelSummary>
              </ExpansionPanel>
            )
          })
          : <NoData title="Модули в данном блоке пока отсутствуют"
                    desc="Добавьте модули"/>
        }
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default withStyles(styles)(ExpandPanelBlock);
